export enum ChatEvents {
  MESSAGE_CREATED = "ChatMessageCreated"
}
